import React from "react";
import { Dialog } from "primereact/dialog";

interface MobileBottomSheetProps {
    visible: boolean;
    onHide: () => void;
    title?: React.ReactNode;
    headerIcon?: string;
    footer?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    closable?: boolean;
    dismissableMask?: boolean;
}

/**
 * MobileBottomSheet
 * -----------------
 * Componente reutilizável que transforma o Dialog do PrimeReact
 * num painel inferior deslizante (Bottom Sheet) nativo.
 */
const MobileBottomSheet: React.FC<MobileBottomSheetProps> = ({
    visible,
    onHide,
    title,
    headerIcon,
    footer,
    children,
    className,
    closable = true,
    dismissableMask = true,
}) => {
    /**
     * Header customizado com drag handle superior e título com ícone
     */
    const headerContent = (
        <div className="flex flex-column w-full pr-2">
            {/* Drag handle — barra decorativa superior */}
            <div
                className="align-self-center"
                style={{
                    width: "36px",
                    height: "4px",
                    borderRadius: "2px",
                    backgroundColor: "#CBD5E1",
                    marginBottom: "12px",
                }}
            />
            {title && (
                <div className="flex align-items-center gap-2">
                    {headerIcon && (
                        <div
                            className="flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "8px",
                                backgroundColor: "#F1F5F9",
                                color: "#0084D1",
                            }}
                        >
                            <i className={`${headerIcon} text-lg`} />
                        </div>
                    )}
                    <span className="text-lg font-semibold" style={{ color: "#0F172A" }}>
                        {title}
                    </span>
                </div>
            )}
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            position="bottom"
            modal
            draggable={false}
            resizable={false}
            closable={closable}
            dismissableMask={dismissableMask}
            header={headerContent}
            footer={footer}
            className={`w-full ${className || ""}`}
            style={{
                margin: 0,
                width: "100%",
                maxWidth: "100%",
                borderRadius: "16px 16px 0 0",
            }}
            contentStyle={{
                maxHeight: "80vh",
                overflowY: "auto",
                padding: "0.5rem 1.25rem 1.25rem",
            }}
            headerStyle={{
                padding: "0.75rem 1.25rem 0.5rem",
                borderBottom: "none",
            }}
            maskStyle={{
                alignItems: "flex-end",
            }}
        >
            {children}
        </Dialog>
    );
};

export default MobileBottomSheet;